import { SERP_CARD_CLICK_GOAL, SERP_VERSION, YANDEX_METRIKA_ID } from '../config';
import type { SerpCardClick } from '../model/serpCardClick';

type GoalType = 'click' | 'focus' | 'input' | 'other';

type TourHunterType = 'region' | 'hotels';

export interface PageHitParams {
  referer: string;
  title: string;
}

export default class YandexTrackingService {
  hit(url: string, params: PageHitParams): void {
    if (!window.ym) {
      return;
    }

    window.ym(YANDEX_METRIKA_ID, 'hit', url, params);
  }

  setTrackingGoal(goal: string, goalType: GoalType, params?: Record<string, unknown>): void {
    if (!window.ym) {
      return;
    }

    if (params) {
      window.ym(YANDEX_METRIKA_ID, 'reachGoal', goal, params);
    } else {
      window.ym(YANDEX_METRIKA_ID, 'reachGoal', goal);
    }

    console.log(`${goalType} ${goal}`);
  }

  bannerThClick(isUserAuth: boolean): void {
    this.bannerThTracking(isUserAuth, 'serp', 'region');
  }

  serpCardClick({ target, hotelId, position, maxViewedPosition, clientUuid, sid, searchUuid }: SerpCardClick): void {
    this.setTrackingGoal(SERP_CARD_CLICK_GOAL, 'click', {
      target,
      hotel_id: hotelId,
      position,
      max_viewed_position: maxViewedPosition,
      serp_version: SERP_VERSION,
      client_uuid: clientUuid,
      sid,
      search_uuid: searchUuid,
    });
  }

  private bannerThTracking(isUserAuth: boolean, funnelStep: string, tourHunterType: TourHunterType): void {
    this.setTrackingGoal('tourhunter_click', 'click', {
      funnel_step: funnelStep,
      user_authorization: isUserAuth,
      placement_banner: true,
      type_of_tourhunter: tourHunterType,
      add_to_tourhunter: true,
    });
  }
}

const yandexTrackingService = new YandexTrackingService();

export { yandexTrackingService };
